module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('selector', {
    attrs: {
      "draggable-group": "music-questions",
      "item-name-plural": "music questions",
      "item-name": "music question",
      "can-add": true,
      "is-fixed": _vm.isFixed,
      "is-editable": _vm.isEditable,
      "search-text": _vm.selectorMatrixChoiceSearchText,
      "show-category-filter": false
    },
    on: {
      "onItemEdit": _vm.handleEditItem,
      "onCreate": _vm.handleCreate,
      "onLoadMore": _vm.handleLoadMore,
      "onResetFilters": _vm.handleResetFilters,
      "onChangeSearchText": _vm.handleSearchText
    },
    model: {
      value: (_vm.musicQuestions),
      callback: function($$v) {
        _vm.musicQuestions = $$v
      },
      expression: "musicQuestions"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b63226f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/selectors/MusicQuestionSelector.vue
// module id = 3230
// module chunks = 3